export default "__VITE_ASSET__Cl$Tnvhl__"